import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-around",
    backgroundColor: theme.additionalColors.lightGray,
    padding: theme.spacing(1.5),
    marginBottom: "10px",
  },
  title: {
    color: "white",
  },
  table: {
    height: "80%",
    overflowY: "scroll",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: "10px",
    position: "absolute",
    bottom: "10px",
    padding: theme.spacing(0, 2),
  },
  saveButton: {
    display: "flex",
    fontSize: "18pt",
    borderRadius: "4px",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "rgb(23, 108, 147)",
    },
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "fixed",
    top: 0,
  },
  progress: {
    margin: theme.spacing(2),
    color: theme.palette.secondary.main,
  },
}));

export default useStyles;
